import MenuInitialRecommendation from './MenuInitialRecommendation.vue';

export const menuInitialRecommendationRoutes = [
  { path: 'menu-initial-recommendation', component: MenuInitialRecommendation, name: 'menu-initial-recommendation' }
];
